// Утилиты для работы с сессией пользователя в sessionStorage.
// Централизуют чтение и запись значений, чтобы не дублировать строковые ключи по проекту.

const KEYS = {
  token: 'token',
  userId: 'user_id',
  userPhone: 'user_phone',
  userName: 'user_name',
  lastLocation: 'last_location',
  lastLocationName: 'last_location_name',
  lastSchema: 'last_schema',
  locId: 'loc_id',
} as const

export type UserInfoPayload = {
  user_id: number | string
  user_phone?: string
  user_name?: string
  last_location_name?: string
  last_location?: { id: number | string } | null
  last_schema?: { id: string | number } | null
}

// Безопасный доступ к sessionStorage (учитывает SSR-окружения).
function safeStorage(): Storage | null {
  if (typeof sessionStorage === 'undefined') {
    return null
  }
  return sessionStorage
}

export function getToken(): string | null {
  return safeStorage()?.getItem(KEYS.token) ?? null
}

export function setToken(token: string): void {
  safeStorage()?.setItem(KEYS.token, token)
}

export function isAuthenticated(): boolean {
  return Boolean(getToken())
}

export function getUserName(): string {
  return safeStorage()?.getItem(KEYS.userName) ?? ''
}

export function getUserPhone(): string {
  return safeStorage()?.getItem(KEYS.userPhone) ?? ''
}

export function getUserId(): string {
  return safeStorage()?.getItem(KEYS.userId) ?? ''
}

export function getLastLocationId(): string {
  return safeStorage()?.getItem(KEYS.lastLocation) ?? ''
}

export function getLastLocationName(): string {
  return safeStorage()?.getItem(KEYS.lastLocationName) ?? ''
}

export function setLastLocation(id: string | number, name: string): void {
  const s = safeStorage()
  if (!s) return
  s.setItem(KEYS.lastLocation, String(id))
  s.setItem(KEYS.lastLocationName, name)
  s.setItem(KEYS.locId, String(id))
}

// Сохранение профиля пользователя после успешного логина.
export function persistUserInfo(data: UserInfoPayload): void {
  const s = safeStorage()
  if (!s) return
  s.setItem(KEYS.userId, String(data.user_id))
  s.setItem(KEYS.userPhone, data.user_phone ?? '')
  s.setItem(KEYS.userName, data.user_name ?? '')
  s.setItem(KEYS.lastLocationName, data.last_location_name ?? '')
  s.setItem(KEYS.lastSchema, data.last_schema ? JSON.stringify(data.last_schema) : '')
  const locId = data.last_location?.id
  s.setItem(KEYS.lastLocation, locId !== undefined && locId !== null ? String(locId) : '')
  s.setItem(KEYS.locId, locId !== undefined && locId !== null ? String(locId) : '')
}

// Полная очистка сессии (используется при логауте).
export function clearSession(): void {
  const s = safeStorage()
  if (!s) return
  for (const key of Object.values(KEYS)) {
    s.removeItem(key)
  }
}
